import { DefaultView, OptionalEditView, Views } from '../../../types/BlockWithViews';
import { asFetchableBlock } from '../../../_lib/BlockFetcher';
import { BlockType } from '../../../types/api/ElementType';
import React, { ComponentProps, useCallback } from 'react';
import { CurrentAccessLevelDefaultView } from './views/CurrentAccessLevelDefaultView';
import { CurrentAccessLevelEditView } from './views/CurrentAccessLevelEditView';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { BlockBar, BlockBarButton } from '../../../_lib/components/BlockBar';
import { Icons } from '../../../components/atoms/SVG';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { CurrentAccessLevelCreateForm } from './partials/CurrentAccessLevelCreateForm';
import { ModalDialogModifier } from '../../../components/organisms/ModalDialog/ModalDialog';

type AccessLevelProps = Views<
  DefaultView<CurrentAccessLevelDefaultView> & OptionalEditView<CurrentAccessLevelEditView>
>;

function CurrentAccessLevel({ views }: AccessLevelProps) {
  const { t } = useSonTranslation('AccessLevel');

  const [showEditModal, setShowEditModal] = React.useState(false);
  const closeModal = useCallback(() => {
    setShowEditModal(false);
  }, []);

  const accessLevelTitleLabel = t(
    `AccessLevel:form.accessLevels.${views.default.embedded.currentAccessLevel.requestedLevel}.title`
  );
  const blockBarHeading = `${t('labels.currentAccessLevelLabel')}: ${accessLevelTitleLabel}`;

  const createForm = views.default.embedded.createRequestForm;

  return (
    <>
      <div className="access-level__current-access-level-blockbar-container">
        <BlockBar heading={blockBarHeading} hierarchy={3}>
          {views.edit ? (
            <BlockBarButton
              ref={undefined}
              onClick={() => {
                setShowEditModal(true);
              }}
              text={t('editRequest')}
              svgSpriteId={Icons.EDIT_PENCIL}
            />
          ) : null}
        </BlockBar>
        {createForm ? <CurrentAccessLevelCreateForm createRequestForm={createForm} /> : null}
      </div>
      <CurrentAccessLevelDefaultView {...views.default} />
      {views.edit && showEditModal && (
        <ModalDialog
          closeModal={closeModal}
          headline={t('form.headline.edit')}
          modifier={ModalDialogModifier.WITH_NAVIGATION}
        >
          <CurrentAccessLevelEditView {...views.edit} />
        </ModalDialog>
      )}
    </>
  );
}

export const CurrentAccessLevelBlock = asFetchableBlock(
  CurrentAccessLevel,
  BlockType.currentAccessLevel,
  BlockType.currentAccessLevel // we need to register this block for useInvalidateRefreshableBlock
);
export type CurrentAccessLevelBlock = ComponentProps<typeof CurrentAccessLevelBlock>;
